export const internalUsers = [
  "Super Admin",
  "Admin",
  "Accountant",
  "Representative",
  "Animator",
  "Agent",
  "Project Manager",
];
export const externalUsers = ["Employee", "Manager"];

// Representative is the sales-rep role. Only Super Admin may create internal users.
export const rolesThatCanCreateUsers = [
  "Super Admin",
  "Admin",
  "Animator",
  "Project Manager",
  "Representative",
];

export const allTypes = [
  "Super Admin",
  "Admin",
  "Accountant",
  "Representative",
  "Animator",
  "Agent",
  "Project Manager",
  "Employee",
  "Manager",
];

export const userTypes_Ids = [
  {
    label: "Super Admin",
    value: "1",
  },
  {
    label: "Admin",
    value: "2",
  },
  {
    label: "Representative",
    value: "3",
  },
  {
    label: "Accountant",
    value: "4",
  },
  {
    label: "Project Manager",
    value: "5",
  },
  {
    label: "Agent",
    value: "6",
  },
  {
    label: "Animator",
    value: "7",
  },
  {
    label: "Manager",
    value: "8",
  },
  {
    label: "Employee",
    value: "9",
  },
];

export const provincesOptions = [
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nunavut", value: "NU" },
  { label: "Yukon", value: "YT" }
];